export default __webpack_public_path__ + "static/Rectangle-314-a101753fc32e21e5f7f3e202bd1fd0e7.jpg";